
import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetClose } from "@/components/ui/sheet";
import { SidebarCoreContent } from './sidebar/SidebarCoreContent';

interface MobileSheetSidebarProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onLinkClick: () => void; // To close the sheet when a link is clicked
}

export const MobileSheetSidebar: React.FC<MobileSheetSidebarProps> = ({ isOpen, onOpenChange, onLinkClick }) => {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      {/* SheetTrigger is usually outside, handled by Navbar's hamburger button */}
      <SheetContent side="left" className="w-[280px] p-0 flex flex-col bg-sidebar border-sidebar-border">
        <div className="flex-grow overflow-y-auto p-4">
          <SidebarCoreContent collapsed={false} onLinkClick={onLinkClick} />
        </div>
      </SheetContent>
    </Sheet>
  );
};
